<ion-chip
  id="getm-tag"
  mode="md"
  [color]="color"
  [ngClass]="
    'getm-tag-' + size + ' ' + 'getm-tag-' + shape + ' ' + 'getm-tag-' + fill
  "
  (click)="onTagClick()"
>
  <ng-container *ngIf="icon && slotIcon === 'left'">
    <ng-container *ngTemplateOutlet="iconTemplate"></ng-container>
  </ng-container>

  <ng-container *ngIf="label">
    <ion-label>{{ label }}</ion-label>
  </ng-container>

  <ng-container *ngIf="icon && slotIcon === 'right'">
    <ng-container *ngTemplateOutlet="iconTemplate"></ng-container>
  </ng-container>
</ion-chip>

<ng-template #iconTemplate>
  <ion-icon
    [name]="icon"
    [ngStyle]="{
      color: 'var(--ion-color-' + iconColor + ')',
      'margin-right':
        slotIcon === 'left' && label ? 'var(--margin-0)' : 'var(--margin-xs)',
      'margin-left':
        slotIcon === 'right' && label ? 'var(--margin-0)' : 'var(--margin-xs)'
    }"
  ></ion-icon>
</ng-template>

<!-- ? NOTA: Modificar el mode ios si se quiere quitar el bounce -->
